import slugify from 'slugify'

export const capitalize = (s?: string): string =>
  s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : ''

export const stringToSlug = (s: string): string =>
  slugify(s, {
    replacement: '-',
    lower: true,
    strict: true
  })

export const getInitials = (name: string) =>
  name
    ?.match(/(^\S\S?|\b\S)?/g)
    ?.join('')
    ?.match(/(^\S|\S$)?/g)
    ?.join('')
    .toUpperCase()
